import SpriteSymbol from "../../../node_modules/svg-sprite-loader/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "left",
  "use": "left-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"left\"><defs><style></style></defs><path d=\"M284.539 526.858l383.764 383.765a35.83 35.83 0 1050.678-50.678l-358.42-358.42 358.42-358.421a35.83 35.83 0 10-50.678-50.678L284.54 476.191c-7.004 7.004-10.496 16.158-10.496 25.344s3.502 18.33 10.496 25.323z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol